export default __webpack_public_path__ + "static/media/(104).ad0cb629.jpg";